import Detachable  from 'ui/mixins/detachable';
import Toggleable  from 'ui/mixins/toggleable';



export default {
  mixins: [Detachable, Toggleable],



  props: {
    disabled: Boolean,
    persistent: {
      type: Boolean,
      default: false,
    },
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition',
    },
    scrollStop: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'default',
    },
    btnClose: {
      type: Boolean,
      default: true,
    },
    width: {
      type: [String, Number],
      default: null,
    },
    limitVw: {
      type: Boolean,
      default: true,
    },
    beforeHide: {
      type: Function,
    },
    system: Boolean,
  },



  computed: {
    classes() {
      return {
        [(`dn-dialog dn-dialog--${this.type} ${this.contentClass}`).trim()]: true,
        'dn-dialog--system': this.system,
        'dn-dialog--active': this.isActive,
        'dn-dialog--limit-vw': this.limitVw,
      }
    },
  },



  watch: {
    isActive(isActive) {
      if (isActive) {
        this.$emit('before-show');

        if (this.scrollStop) {
          this.hideScroll();
        }
      } else {
        this.$emit('before-hide');
        this.showScroll();
      }
    },
  },



  methods: {
    toggle() {
      if (!this.disabled) this.isActive = !this.isActive;
    },

    show() { this.isActive = true },
    hide() {
      let beforeHide;
      if (typeof this.beforeHide === 'function') beforeHide = this.beforeHide();
      if (beforeHide !== false) this.isActive = false;
    },

    closeConditional(e) { return !this.persistent },

    showScroll() { dn.window.setScrollDisabled(false) },
    hideScroll() { dn.window.setScrollDisabled() },
  },



  beforeDestroy() {
    this.showScroll();
  },




  render(h) {
    const my = this;
    const children = [];

    if (this.$slots.activator) {
      const $activator = h('div', {
        'class': 'dn-dialog__activator',
        on: {
          click: e => {
            e.stopPropagation();
            this.toggle();
          },
        },
      }, [this.$slots.activator]);
      children.push($activator);
    }

    const bodyWrapperChildren = [];
    const bodyChildren = [];

    if (this.$slots.header) {
      bodyChildren.push(h('div', {
        'class': 'dn-dialog__header',
      }, this.$slots.header));
    }

    bodyChildren.push(this.$slots.default);

    if (this.$slots.footer) {
      bodyChildren.push(h('div', {
        'class': 'dn-dialog__footer',
      }, this.$slots.footer));
    }

    bodyWrapperChildren.push(h('div', {
      'class': 'dn-dialog__body',
      style: {
        width: this.width ? (isNaN(this.width) ? this.width : `${this.width}px`) : null,
      },
    }, bodyChildren));

    if (this.btnClose) {
      bodyWrapperChildren.push(h('a', {
        'class': 'dn-dialog__btn-close',
        attrs: {
          href: 'javascript:void(0);'
        },
        on: {
          click: e => {
            e.stopPropagation();
            this.hide();
          },
        },
        ref: 'btn-close',
      }, [h('dn-icon', {
        props: {icon: 'close-box'},
      })]));
    }

    const $body = h('div', {
      'class': 'dn-dialog__body-wrapper',
      directives: [
        {
          name: 'click-outside',
          value: this.closeConditional,
        },
      ],
    }, bodyWrapperChildren);

    const $inner = h('div', {
      'class': 'dn-dialog__inner',
    }, [$body]);

    const $table = h('div', {
      'class': 'dn-dialog__table',
    }, [$inner]);

    const $dialog = h('div', {
      'class': this.classes,
      ref: 'content',
      directives: [
        { name: 'show', value: this.isActive },
      ],
    }, [$table]);

    const $transition = h('transition', {
      props: { name: this.transition },
    }, [$dialog]);

    children.push($transition);

    const $container = h('div', {
      'class': 'dn-dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || 'inline-block',
      },
    }, children);

    return $container;
  },
}



// WEBPACK FOOTER //
// ./src/js/ui/components/dialogs/Dialog.js